import { useEffect, useMemo, useRef } from "react";
import { useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import HeaderCustomer from "./HeaderCustomer";
import "./Customer.css";
import CustomerFooter from "./CustomerFooter";
import { AiOutlineDelete } from "react-icons/ai";
import axios from "axios";
import Typeahead from "../Typeahead";
import GenericSearch, {
  ContentResults,
  ReloadButton,
  hasGenCode,
  useContentSearch,
} from "./GenericSearch";
import { useDispatch, useSelector } from "react-redux";
import GlobalVariable from "../../GlobalVariable";
// Order / Order Upload / Order by Comp all place orders against the GROUP
// (_SARVODAYA), so every wClientId here is GlobalVariable.groupId rather
// than the single firm id used by the reports.
import ApiHandler, { refreshTokenQuiet } from "../../ApiHandler";
import { toast } from "react-toastify";
import { userOrderAction } from "./Userproducts/UserOrders";
import useGlobalEvent from "beautiful-react-hooks/useGlobalEvent";

// import { Carousel, Image } from 'react-bootstrap';
import { Image, Carousel } from "antd";
import { Result } from "antd";
import LoaderTri from "../Loader/LoaderTri";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

// Column order of the search dropdown. `cols` are Bootstrap grid widths and
// have to add up to 12.
const productsColumns = [
  {
    header: "Product Name",
    field: "prodName",
    cols: 3,
  },
  {
    header: "Pack",
    field: "case1",
    cols: 2,
  },
  {
    header: "Scheme",
    field: "scheme",
    cols: 1,
  },
  {
    header: "Stock",
    field: "stock",
    cols: 2,
  },
  {
    header: "Rate",
    field: "rate",
    cols: 1,
  },
  {
    header: "Mrp",
    field: "mrp",
    cols: 1,
  },
  {
    header: "Company",
    field: "companyName",
    cols: 2,
  },
  // {
  //     header: "Gst",
  //     field: "pGST",
  //     cols: 1,
  // },
];

/**
 * The search result carries up to three scheme slots as flat fields -
 * schQ1/schF1/schDisc1 .. schQ3/schF3/schDisc3 - which are the same thing as
 * the mobile app's `schemes` list of { qty, freeQty, discPer }.
 */
const toSchemes = (product) => {
  if (!product) return [];
  return [1, 2, 3].map((n) => ({
    qty: Number(product["schQ" + n]) || 0,
    freeQty: Number(product["schF" + n]) || 0,
    discPer: Number(product["schDisc" + n]) || 0,
  }));
};

/**
 * Free quantity for an ordered quantity, ported from the mobile app's
 * schemeCalculation: walk the scheme slots, and for each one give freeQty for
 * every whole multiple of qty that is left. A slot carrying a discount
 * percentage switches the product to a percentage scheme, which has no free
 * quantity at all.
 */
const schemeCalculation = (quantity, schemes) => {
  const list = Array.isArray(schemes) ? schemes : [];
  let search = parseInt(quantity, 10);
  if (!Number.isFinite(search)) search = 0;

  let free = 0;
  let percent = false;

  for (let i = 0; i < list.length; i++) {
    if (list[i].discPer > 0) {
      percent = true;
      break;
    }
    if (list[i].qty > 0) {
      while (search >= list[i].qty) {
        free = free + list[i].freeQty;
        search = search - list[i].qty;
      }
    }
  }

  if (percent) {
    let discPer = 0;
    for (let i = 0; i < list.length; i++) {
      if (list[i].qty > 0 && search >= list[i].qty) {
        discPer = list[i].discPer;
        break;
      }
    }
    return { percent: true, discPer: discPer, free: 0 };
  }

  return { percent: false, discPer: 0, free: free };
};

// the free quantity on its own - what the Free box shows
const schemeFree = (quantity, schemes) =>
  schemeCalculation(quantity, schemes).free;

const indialOrder = {
  // wClientid: GlobalVariable.W2,
  wClientid: GlobalVariable.groupId,
  CustCode: 0,
  repcode: 0,
  // uniqueOrderID: GlobalVariable.W2,
  uniqueOrderID: GlobalVariable.groupId,
  orderType: "web",
  rclientid: null,
  urgent: 0,
  remarks: "",
  mobNo: "",
  orderItems: [],
};

export const selectedProductNameLocalStorage = "selcted-Products";

let LoadCountForSetOrderItem = 0;

export default function CustomerDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const grandTotalvalues = useSelector(
    (state) => state.userOrders.increaseprice
  );
  const [smShow, setSmShow] = useState(false);
  const [newProduct, setNewProduct] = useState([]);
  const [compName, setCompName] = useState();
  const [selectedProductName, setselectedProductName] = useState();
  const [selectedcase1, setselectedcase1] = useState();
  const [selectedScheme, setselectedScheme] = useState(0);
  const [selectedStock, setselectedStock] = useState();
  const [selectedPrice, setselectedPrice] = useState();
  const [rates, setRates] = useState();
  const [increasePrice, setIncreasePrice] = useState(0);
  const [hideDateTime, sethideDateTime] = useState(false);
  const [data, setData] = useState(0);
  const [visible, setVisible] = useState(false);
  const [noOfquantity, setNoOfQuantity] = useState(1);
  // free quantity, shown in the product dialog when OwnAppConfigs'
  // autoSchemeCust allows it: 0 hides it, 1 shows it read-only, 3 lets the
  // customer edit it
  const [noOfFree, setNoOfFree] = useState(0);
  const [autoScheme, setAutoScheme] = useState(0);
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remarksMessage, setRemarksMessage] = useState("--Select--");
  const [input, setInput] = useState("");
  const [productCode, setProductCode] = useState("");
  const [zIndex, setZIndex] = useState("1");

  const qtyInputRef = useRef();

  const userOrders = useSelector((state) => state.userOrders);

  let selectedProductsLocalStorage = useMemo(() => {
    let temp = JSON.parse(
      localStorage.getItem(selectedProductNameLocalStorage)
    );
    temp = temp ? temp : [];
    return temp;
  }, []);

  const [order, setOrder] = useState({
    ...indialOrder,
    orderItems: [...selectedProductsLocalStorage],
    remarks: userOrders.remarksMessageBYcomp,
  });

  const [showStock, setShowStock] = useState();
  const [localURL, setLocalURL] = useState("");
  const [showRemarks, setshowRemarks] = useState(false);
  const [sumValue, setsumValue] = useState(grandTotalvalues);
  const [prodGST, setProdGST] = useState(0);
  const [orderclosed, setorderclosed] = useState();
  const [sildeimgURL1, setsildeimgURL1] = useState();
  const [sildeimgURL2, setsildeimgURL2] = useState();
  const [sildeimgURL3, setsildeimgURL3] = useState();
  const [sildeimgURL4, setsildeimgURL4] = useState();
  const [sildeimgURL5, setsildeimgURL5] = useState();
  const [show, setShow] = useState(false);
  const [submitOrderNo, setsubmitOrderNo] = useState();
  const [orderSuccess, setorderSuccess] = useState();
  const [handleOpen, sethandleOpen] = useState(false);
  const [dataSTATUS, setdataSTATUS] = useState();
  let pickuporder = "PickUp Order";
  let deliveryOrder = "Delivery Order";

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const onWindowResize = useGlobalEvent("resize");
  onWindowResize(() => {
    setWindowHeight(window.innerHeight);
    setWindowWidth(window.innerWidth);
  });

  const searchProduct = useSelector((state) => state.userOrders.searchProduct);
  const customerCompMessage = useSelector(
    (state) => state.userOrders.remarksMessageBYcomp
  );

  // var p = searchProduct.concat(searchProduct)
  // console.log(p);

  // var p = order.orderItems.concat(searchProduct)
  // useEffect(() => {
  //     var l = p.reduce((n, i) => {
  //         console.log(order.orderItems);
  //         if (!n.find((val) => val.productCode === i.productCode)) {
  //             n.push(i)

  //         }

  //         return n

  //     }, [])
  //     console.log(l);
  // }, [p, order.orderItems])

  useEffect(() => {
    // console.log("userOrderss", userOrders);
  }, [userOrders, searchProduct]);

  // after click, it will be false
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true)
  const refOne = useRef(null);

  useEffect(() => {
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, [grandTotalvalues]);

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setshowRemarks(false);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user-info"));
    // OwnAppConfigs is keyed by the userId the login response returns - not
    // by a client id. (It was the group id here, and a firm id before that.)
    const configId =
      (user && user.userId) || localStorage.getItem("user-id") || "";
    axios({
      url:
        GlobalVariable.ReliableSoftURL +
        "/api/OwnAppConfigs/" +
        configId,
      method: "GET",
      headers: {
        Authorization: "Bearer " + user.token,
      },
    })
      .then((res) => {
        //    console.log(res.data)
        //  console.log(res.data.showStocktoCust)
        setShowStock(res.data.showStocktoCust);
        setAutoScheme(Number(res.data.autoSchemeCust));
        setLocalURL(res.data.localUrl);
        localStorage.setItem("LocalURL", JSON.stringify(res.data.localUrl));

        setorderclosed(res.data.orderClosedCust);
        setsildeimgURL1(res.data.bannerUrl1);
        setsildeimgURL2(res.data.banerUrl2);
        setsildeimgURL3(res.data.banerUrl3);
        setsildeimgURL4(res.data.banerUrl4);
        setsildeimgURL5(res.data.banerUrl5);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  // useEffect(() => {
  //   window.localStorage.setItem("LocalURL", JSON.stringify(localURL));

  //   return () => {};
  // }, [localURL]);

  useEffect(() => {
    setOrder((v) => {
      const user = JSON.parse(localStorage.getItem("user-info"));
      const date = new Date();
      return {
        //   ...v, uniqueOrderID: GlobalVariable.W2 + "_" + user.code + "_" +
        ...v,
        uniqueOrderID:
          GlobalVariable.groupId +
          "_" +
          user.code +
          "_" +
          date.getDay() +
          date.getMonth() +
          date.getFullYear() +
          date.getHours() +
          date.getMinutes() +
          date.getSeconds() +
          date.getMilliseconds() * 100000,

        //   ...v, uniqueOrderID: wcClient + "_" + user.code + "_" + new Date()
      };
    });
  }, []);

  const token = JSON.parse(localStorage.getItem("user-info"));

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user-info"));
    user &&
      user.code &&
      setOrder((v) => {
        return { ...v, CustCode: user.code };
      });

  }, []);

  const user = useMemo(() => JSON.parse(localStorage.getItem("user-info")), []);

  // A product picked - from the product search OR the generic search -
  // opens the quantity dialog with its details.
  const pickProduct = (elm) => {
    if (!elm) return;
    setSmShow(true);
    setVisible(false);
    setCompName(elm.companyName);
    setselectedProductName(elm.prodName);
    setselectedcase1(elm.case1);
    setselectedScheme(elm.scheme);
    setselectedStock(elm.stock);
    setselectedPrice(elm.mrp);
    setRates(elm.rate);
    setProductCode(elm.prodCode);
    setProdGST(elm.gst);

    // free comes from the product's own scheme slots, for the
    // quantity the dialog opens on (1)
    const schemes = toSchemes(elm);
    setSelectedSchemes(schemes);
    setNoOfQuantity(1);
    setNoOfFree(schemeFree(1, schemes));
  };

  // Search box mode: "product" (by product name) or "generic"
  const [searchMode, setSearchMode] = useState("product");

  // Product-name search: the "same content" reload on a dropdown row lists
  // every product with that product's content (ProductByGenericCodeGroupNew,
  // search "<prodCode before '.'>.<genCode>") in a panel under the box.
  const productContent = useContentSearch();
  const productTaRef = useRef(null);
  const reloadFromProductSearch = (p) => {
    // close the dropdown so the results under the box can be seen
    const ta = productTaRef.current;
    if (ta) {
      if (typeof ta.hideMenu === "function") ta.hideMenu();
      if (typeof ta.blur === "function") ta.blur();
    }
    productContent.reload(p);
  };

  function SearchHandler(text) {
    setLoading(true);
    ApiHandler.post({
      url: "/api/Search/ProductByName/",
      data: {
        wClientid: GlobalVariable.groupId + "",
        search: text,
        areaCode: user.areaCode + "",
      },
    })
      .then((res) => {
        // console.log(res.data);
        const mappedData = res.data.map((data) => {
          return {
            // ...data, stock: showStock ? "YES (" + data.stock + ")" : "No",
            //  ...data, stock: showStock === true && data.stock > 0 ? "YES" : "NO",
            // ...data, stock: showStock === true ? data.stock + ' ' : data.stock > 0 ? "YES" : "NO",
            ...data,
            // The quantity itself, in the search dropdown and in the product
            // dialog. The original mapped it through showStocktoCust, which
            // turned it into YES / NO whenever that flag was off, and capped
            // it at "500+" when it was on.
            stock: data.stock,
          };
        });
        setNewProduct(mappedData);
      })
      .catch((err) => {
        console.error(err);
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          console.log(err.response);
          //   RefreshTokenHandler();
          //  ToastError("Token has expired Please refresh");
        }
        setNewProduct([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    let total = 0;

    order.orderItems &&
      Array.isArray(order.orderItems) &&
      order.orderItems.forEach((data) => {
        const amt =
          (data.qty ? parseFloat(data.qty) : 0) *
          (data.rte ? parseFloat(data.rte) : 0);
        const taxableAmt =
          (amt * (data.pGst ? parseFloat(data.pGst) : 0)) / 100;
        total += amt + taxableAmt;
      });

    setIncreasePrice(total.toFixed(2));
  }, [order]);

  function addValuehandler(e, i) {
    setSmShow(false);

    let x = JSON.parse(localStorage.getItem(selectedProductNameLocalStorage));
    x = x ? x : [];
    // let p = x.concat(temp.orderItems)
    // console.log(p);
    let exists = false;
    x.forEach((element) => {
      if (element.productCode === productCode) {
        element.qty = noOfquantity ? noOfquantity : 1;
        element.free =
          autoScheme === 0 ? 0 : Number(noOfFree) || 0;
        exists = true;
      }
    });

    if (exists === false) {
      const temp = {
        ...order,
        orderItems: [
          ...x,
          {
            slno: data + 1,
            productCode: productCode,
            comp1: compName,
            prd1: selectedProductName,
            cs1: selectedcase1,
            sc1: selectedScheme,
            mrp1: selectedPrice,
            qty: noOfquantity ? noOfquantity : 1,
            free: autoScheme === 0 ? 0 : Number(noOfFree) || 0,
            schemes: selectedSchemes,
            rte: rates,
            pGst: prodGST,
            showTime: new Date(),
          },
        ],
      };
      setOrder(temp);
      dispatch(userOrderAction.setProductData(temp.orderItems));
      console.log(temp.orderItems);
      localStorage.setItem(
        selectedProductNameLocalStorage,
        JSON.stringify(temp.orderItems)
      );
      setData(data + 1);
    } else {
      setOrder((v) => {
        return {
          ...v,
          orderItems: x,
        };
      });
      dispatch(userOrderAction.setProductData(x));
      console.log(x);
      localStorage.setItem(selectedProductNameLocalStorage, JSON.stringify(x));
    }
  }

  // useEffect(() => {
  //     console.log("orderitems ", order.orderItems)
  // }, [order.orderItems])

  function onEnterAddValuehandler(e, i) {
    if (e.key === "Enter") {
      setSmShow(false);

      //console.log(grandTotalvalue += increasePrice * e.target.value)
      //const date = new Date();

      let x = JSON.parse(localStorage.getItem(selectedProductNameLocalStorage));
      x = x ? x : [];
      // let p = x.concat(temp.orderItems)
      // console.log(p);
      let exists = false;
      x.forEach((element) => {
        if (element.productCode === productCode) {
          element.qty = noOfquantity ? noOfquantity : 1;
          element.free =
            autoScheme === 0 ? 0 : Number(noOfFree) || 0;
          exists = true;
        }
      });

      if (exists === false) {
        const temp = {
          ...order,
          orderItems: [
            ...x,
            {
              slno: data + 1,
              productCode: productCode,
              comp1: compName,
              prd1: selectedProductName,
              cs1: selectedcase1,
              sc1: selectedScheme,
              mrp1: selectedPrice,
              qty: noOfquantity ? noOfquantity : 1,
              free: autoScheme === 0 ? 0 : Number(noOfFree) || 0,
              schemes: selectedSchemes,
              rte: rates,
              pGst: prodGST,
              showTime: new Date(),
            },
          ],
        };
        setOrder(temp);
        dispatch(userOrderAction.setProductData(temp.orderItems));
        console.log(temp.orderItems);
        localStorage.setItem(
          selectedProductNameLocalStorage,
          JSON.stringify(temp.orderItems)
        );
        setData(data + 1);
      } else {
        setOrder((v) => {
          return {
            ...v,
            orderItems: x,
          };
        });
        dispatch(userOrderAction.setProductData(x));
        console.log(x);
        localStorage.setItem(
          selectedProductNameLocalStorage,
          JSON.stringify(x)
        );
      }
    }
  }

  function DeleteData(i, productCode) {
    dispatch(userOrderAction.removeItem({ i, productCode }));
    setVisible(!visible);
    setOrder((v) => {
      v.orderItems = v.orderItems.filter((c) => c.productCode !== productCode);
      return { ...v };
    });
  }

  const [productSeach, setProductSeach] = useState({
    options: [],
    selected: [],
    search: "",
  });

  const [errorMessage, setErrorMessage] = useState("Could Not save");

  function submitDatahandler(e) {
    e.preventDefault();

    setIsLoading(true);

    let requestData = {
      ...order,
      orderItems: order.orderItems.map((e) => {
        return {
          wProdCode: e.productCode,
          qty: e.qty,
          free: Number(e.free) || 0,
          ProductName: e.prd1 || e.prodName,
          price: e.mrp1 || e.mrp,
          entryTime: e.showTime,
          rProdCode: "",
          packs: e.cs1 || e.case1,
          wBarcode: "",
          sourceId: 0,
        };
      }),
      remarks:
        remarksMessage === "--Select--" ? customerCompMessage : remarksMessage,
    };

    // Read the token at submit time, not render time: a cart can take long
    // enough to build that the token captured on page load has expired. On a
    // 401, renew it quietly and resend once - same uniqueOrderID, so the
    // server cannot record the order twice - keeping the cart intact.
    const postOrder = () => {
      const u = JSON.parse(localStorage.getItem("user-info")) || {};
      return axios.post(
        GlobalVariable.ReliableSoftURL + "api/Orders/WritePopsOrders/",
        requestData,
        { headers: { Authorization: "Bearer " + u.token } }
      );
    };

    postOrder()
      .catch((err) => {
        if (!(err.response && err.response.status === 401)) throw err;
        return refreshTokenQuiet()
          .catch(() => {
            const e2 = new Error(
              "Your session has expired. Please log out and log in again - your cart is saved."
            );
            throw e2;
          })
          .then(postOrder)
          .catch((e3) => {
            if (e3.response && e3.response.status === 401) {
              e3.message =
                "Order not accepted for this login (401). Please log out and log in again - your cart is saved.";
            }
            throw e3;
          });
      })
      .then((res) => {
        const user = JSON.parse(localStorage.getItem("user-info"));
        const date = new Date();

        setOrder({
          ...indialOrder,
          CustCode: user.code,
          orderItems: [],
          remarks: "",
          uniqueOrderID:
            GlobalVariable.groupId +
            "_" +
            user.code +
            "_" +
            date.getDay() +
            date.getMonth() +
            date.getFullYear() +
            date.getHours() +
            date.getMinutes() +
            date.getSeconds() +
            date.getMilliseconds() * 100000,
        });


        console.log(res);
        console.log(res.headers.status);
        setdataSTATUS(res.headers.status);
        setorderSuccess(res.data.status);
        setsubmitOrderNo(res.data.orderNo);

        console.log(requestData);
        setData(requestData.SrNo + 1);
        localStorage.setItem(
          selectedProductNameLocalStorage,
          JSON.stringify([])
        );
      })
      .catch((err) => {
        console.error(err);

        err.message && setErrorMessage(err.message);
        setorderSuccess("Failed");
      })
      .finally(() => {
        setShow(true);

        setIsLoading(false);
      });
  }

  // var searchProductData = []
  // useEffect(() => {
  // var searchProductData = JSON.parse(localStorage.getItem(selectedProductNameLocalStorage));
  // console.log(searchProductData)
  // }, [])

  // useEffect(() => {
  //     const saveToAllData = { searchProduct }
  //     console.log(saveToAllData);
  //     window.localStorage.setItem("selcted-Products-orderbyComp", JSON.stringify(saveToAllData));
  // });

  var obj = {
    img1: sildeimgURL1,
    img2: sildeimgURL2,
    img3: sildeimgURL3,
    img4: sildeimgURL4,
    img5: sildeimgURL5,
  };

  var imges = [];

  if (obj.img1) {
    imges.push(obj.img1);
  }

  if (obj.img2) {
    imges.push(obj.img2);
  }

  if (obj.img3) {
    imges.push(obj.img3);
  }

  if (obj.img4) {
    imges.push(obj.img4);
  }
  if (obj.img5) {
    imges.push(obj.img5);
  }
  return (
    <div className="custShell">
      <HeaderCustomer />

      <div className="CustomerSubmitSection">
        <div className="custMain">
          <div className="orderHead">
            <h1 className={"orderTitle" + (orderclosed === true ? " orderTitleClosed" : "")}>
              {orderclosed === true ? "Order Closed" : "Place Order"}
            </h1>
          </div>
          {isLoading && (
            <div
              style={{
                position: "absolute",
                top: "0%",
                left: "0%",
                width: "100%",
                height: "100%",
                // right: -1,
                backgroundColor: "#ffffff91",
                zIndex: 999,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  alignContent: "center",
                  flexWrap: "wrap",
                  flexDirection: "row",
                  height: "100%",
                }}
              >
                <LoaderTri height="120" width="120" />
              </div>
            </div>
          )}

          {/* `row` used to sit in the id attribute here, so the Bootstrap grid
              never applied and the column classes below did nothing. */}
          <div className="searchWrap">
            <label className="searchLabel" htmlFor={searchMode === "generic" ? "searchGeneric" : "searchProduct"}>
              Add a product to this order
            </label>

            {/* search by product name, or by generic name */}
            <div className="searchMode" role="tablist" aria-label="Search by">
              {[
                { key: "product", label: "Product name" },
                { key: "generic", label: "Generic name" },
              ].map((m) => (
                <button
                  key={m.key}
                  type="button"
                  role="tab"
                  aria-selected={searchMode === m.key}
                  className={"searchModeBtn" + (searchMode === m.key ? " searchModeOn" : "")}
                  onClick={() => setSearchMode(m.key)}
                >
                  {m.label}
                </button>
              ))}
            </div>

            {searchMode === "generic" ? (
              <GenericSearch
                columns={productsColumns}
                onPick={pickProduct}
                onFocus={() => setZIndex("-1")}
                onBlur={() => setZIndex("1")}
              />
            ) : (
            // genSearch: keeps the box + dropdown above the results panel
            <div className="px-0 genSearch">
              <Typeahead
                stock={selectedStock}
                //showStock={showStock}
                // style={{ width: windowWidth < 500 ? "25%" : "1200px", zIndex: 0 }}
                style={{ width: "100%", zIndex: 0 }}
                placeholder="Search Product"
                id="searchProduct"
                ref={productTaRef}
                rowActionHeader="Same content"
                rowAction={(p) =>
                  hasGenCode(p) ? (
                    <ReloadButton product={p} onReload={reloadFromProductSearch} />
                  ) : null
                }
                //className="w-75"
                className="searchProduct"
                labelKey="prodName"
                name="prodName"
                columns={productsColumns}
                colWidth={window.screen.width}
                isLoading={false}
                onFocus={() => {
                  console.log("focus");
                  setZIndex("-1");
                }}
                onBlur={() => {
                  setZIndex("1");
                  console.log("blur");
                }}
                //when typing in the text box search in handled here
                onSearch={(e) => {
                  // console.log(e);
                  setProductSeach({ ...productSeach, search: e });
                  SearchHandler(e);
                }}
                // when value is choosen or selected
                onChange={(e) => pickProduct(e[0])}
                options={newProduct ? newProduct : []}
                selected={productSeach.selected ? productSeach.selected : []}
              />
              {/* same-content products, from the reload on a dropdown row */}
              <ContentResults
                content={productContent}
                columns={productsColumns}
                onPick={pickProduct}
                onClose={productContent.clear}
              />
            </div>
            )}
            <p className="searchHint">
              {searchMode === "generic"
                ? "Type at least 2 letters of the generic name, pick it, then click one of its products."
                : "Type at least 2 letters of the product name, then pick it from the list to set the quantity."}
            </p>
          </div>

          {/* `row` sat in the id attribute here too, so the grid never
              applied. Scrolling and colours moved to Customer.css. */}
          <div className="orderTableWrap">
            <div className="orderTableScroll">
                <Table striped bordered variant=" " className="orderTable">
                  <thead>
                    <tr>
                      <th>#</th>
                      {hideDateTime ? <th>Time</th> : null}

                      <th>Product Name</th>
                      <th>Packing</th>
                      <th>Scheme</th>
                      <th>MRP</th>
                      <th className="orderQtyHead">Quantity</th>
                      {autoScheme !== 0 ? (
                        <th className="orderFreeHead">Free</th>
                      ) : null}
                      <th>Rate</th>
                      {hideDateTime ? <th>Gst</th> : null}
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      // order.orderItems && Array.isArray(order.orderItems) && order.orderItems.map((data, i) => {
                      order.orderItems.map((data, i) => {
                        //searchProductData && Array.isArray(searchProductData) && searchProductData.map((data, i) => {
                        const indexFix = i;
                        return (
                          <tr key={i}>
                            {/* <td>{data.slno === i || i + 1}</td> */}

                            {/* <td>{data.slno !== i ? i + 1 : ++i}</td> */}
                            {/* <td>{data.slno || ++i}</td> */}

                            {hideDateTime ? <td> {data.showTime}</td> : null}

                            <td>{indexFix + 1}</td>
                            <td>{data.prd1 || data.prodName}</td>
                            <td>{data.cs1 || data.case1}</td>
                            <td>{data.sc1 || data.scheme}</td>
                            <td>{data.mrp1 || data.mrp}</td>
                            <td className="orderQtyCell">
                              <input
                                type="number"
                                min={0}
                                value={data.qty ? data.qty : ""}
                                onChange={(e) => {
                                  // if (order.orderItems && Array.isArray(order.orderItems) && order.orderItems[i]) {
                                  //if (searchProduct && Array.isArray(searchProduct) && searchProduct[i]) {

                                  setOrder((prev) => {
                                    let res = prev;
                                    res.orderItems = prev.orderItems.map(
                                      (elm, indexChange) => {
                                        if (
                                          elm.productCode === data.productCode
                                        ) {
                                          console.log({
                                            "OnchNge value ": e.target.value,
                                          });
                                          return {
                                            ...elm,
                                            qty: e.target.value,
                                            // the scheme's free quantity
                                            // follows the quantity
                                            free:
                                              autoScheme === 0
                                                ? 0
                                                : schemeFree(
                                                  e.target.value,
                                                  elm.schemes
                                                ),
                                          };
                                        }
                                        return { ...elm };
                                      }
                                    );
                                    localStorage.setItem(
                                      selectedProductNameLocalStorage,
                                      JSON.stringify(res.orderItems)
                                    );
                                    console.log("prev ", prev.orderItems[0]);

                                    return { ...prev };
                                  });
                                  // }

                                  // dispatch(userOrderAction.setQty({ index: indexFix, value: e.target.value }))
                                  //  dispatch(userOrderAction.setQtys({ index: i, value: e.target.value }))
                                }}
                                className="form-control orderQtyInput"
                                aria-label="Quantity"
                              />
                            </td>

                            {/* Free mirrors the quantity column, and follows
                                autoSchemeCust: hidden at 0, read-only at 1,
                                editable at 3. */}
                            {autoScheme !== 0 ? (
                              <td className="orderQtyCell orderFreeCell">
                                {autoScheme === 3 ? (
                                  <input
                                    type="number"
                                    min={0}
                                    value={data.free ? data.free : ""}
                                    onChange={(e) => {
                                      setOrder((prev) => {
                                        let res = prev;
                                        res.orderItems = prev.orderItems.map(
                                          (elm) => {
                                            if (
                                              elm.productCode ===
                                              data.productCode
                                            ) {
                                              return {
                                                ...elm,
                                                free: e.target.value,
                                              };
                                            }
                                            return { ...elm };
                                          }
                                        );
                                        localStorage.setItem(
                                          selectedProductNameLocalStorage,
                                          JSON.stringify(res.orderItems)
                                        );
                                        return { ...prev };
                                      });
                                    }}
                                    className="form-control orderQtyInput orderFreeInput"
                                    aria-label="Free"
                                  />
                                ) : (
                                  <span className="orderFreeValue">
                                    {data.free ? data.free : 0}
                                  </span>
                                )}
                              </td>
                            ) : null}

                            <td>{data.rte || data.rate}</td>
                            <td className="orderActionCell">
                              <button
                                type="button"
                                className="orderDeleteBtn"
                                title="Remove this item"
                                onClick={() => {
                                  DeleteData(i, data.productCode);
                                }}
                              >
                                <AiOutlineDelete />
                                <span>Delete</span>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </Table>
            </div>
          </div>

          <Modal
            size="lg"
            centered
            dialogClassName="prodModal"
            show={smShow}
            onHide={() => setSmShow(false)}
            aria-labelledby="contained-modal-title-vcenter"
            onEntered={() => {
              qtyInputRef.current && qtyInputRef.current.focus();
            }}
          >
            {/* Was a #2EC8A6 teal header, the details as bare `col-xl-4`
                divs inside one bordered row, a form-control-sm quantity box
                and an Add Product button carrying `margin-left: 620px`. */}
            <Modal.Header closeButton className="prodModalHead">
              <Modal.Title className="prodModalTitle">
                {selectedProductName}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="prodModalBody">
              <div className="prodCompany">{compName}</div>

              <dl className="prodGrid">
                <div className="prodCell">
                  <dt>Packing</dt>
                  <dd>{selectedcase1}</dd>
                </div>
                <div className="prodCell">
                  <dt>Scheme</dt>
                  <dd>{selectedScheme ? selectedScheme : "-"}</dd>
                </div>
                <div className="prodCell">
                  <dt>Case</dt>
                  <dd>-,-</dd>
                </div>
                <div className="prodCell">
                  <dt>Rate</dt>
                  <dd>{rates}</dd>
                </div>
                <div className="prodCell">
                  <dt>MRP</dt>
                  <dd>{selectedPrice}</dd>
                </div>
                <div className="prodCell">
                  <dt>Stock</dt>
                  <dd>
                    <span
                      className={
                        "prodStock " +
                        (parseFloat(selectedStock) > 0
                          ? "prodStockIn"
                          : "prodStockOut")
                      }
                    >
                      {selectedStock}
                    </span>
                  </dd>
                </div>
                <div className="prodCell">
                  <dt>Min</dt>
                  <dd>0</dd>
                </div>
              </dl>

              <div className="prodQty">
                <label className="prodQtyLabel" htmlFor="prodQty">
                  Quantity
                </label>
                <input
                  id="prodQty"
                  min={0}
                  ref={qtyInputRef}
                  type="number"
                  placeholder="0"
                  className="form-control prodQtyInput"
                  onChange={(e) => {
                    setNoOfQuantity(e.target.value);
                    // the scheme decides the free quantity
                    setNoOfFree(schemeFree(e.target.value, selectedSchemes));
                  }}
                  onKeyPress={onEnterAddValuehandler}
                />

                {/* Free follows OwnAppConfigs' autoSchemeCust: 0 hides it,
                    1 shows it as a read-only figure, 3 lets it be edited. */}
                {autoScheme !== 0 ? (
                  <span className="prodFree">
                    <label className="prodQtyLabel" htmlFor="prodFree">
                      Free
                    </label>
                    {autoScheme === 3 ? (
                      <input
                        id="prodFree"
                        min={0}
                        type="number"
                        placeholder="0"
                        value={noOfFree}
                        className="form-control prodQtyInput prodFreeInput"
                        onChange={(e) => setNoOfFree(e.target.value)}
                        onKeyPress={onEnterAddValuehandler}
                      />
                    ) : (
                      <span className="prodFreeValue">{noOfFree}</span>
                    )}
                  </span>
                ) : null}

                <span className="prodQtyHint">Press Enter to add</span>
              </div>
            </Modal.Body>

            <Modal.Footer className="prodModalFoot">
              <Button className="BtnsA" onClick={addValuehandler}>
                Add Product
              </Button>
            </Modal.Footer>
          </Modal>

          <div className="row m-0">
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 offset-xl-2">
              <div className="orderFinalize">
                <div className="ofHead">Finalize order</div>

                <div className="ofField">
                  <label className="ofLabel" htmlFor="orderPriority">
                    Priority
                  </label>
                  <select id="orderPriority" className="ofSelect">
                    <option value="Normal">Normal</option>
                    <option value="Urgent">Urgent</option>
                  </select>
                </div>

                <div className="ofField ofRemarksWrap">
                  <label className="ofLabel">Remarks</label>

                  <div
                    className="Remarks_list"
                    role="button"
                    tabIndex={0}
                    onClick={() => setshowRemarks(true)}
                    onKeyDown={(e) =>
                      (e.key === "Enter" || e.key === " ") && setshowRemarks(true)
                    }
                  >
                    <span className="ofRemarksText">
                      {customerCompMessage && remarksMessage
                        ? customerCompMessage
                        : remarksMessage}
                    </span>
                    <span className="ofCaret" aria-hidden="true" />
                  </div>

                  {showRemarks && (
                    <div className="selection-remarks-list" ref={refOne}>
                      <li
                        name="PickUpOrder"
                        onClick={() =>
                          setRemarksMessage(pickuporder) + setshowRemarks(false)
                        }
                        value="PickupOrder"
                      >
                        Pickup Order
                      </li>
                      <li
                        onClick={() =>
                          setRemarksMessage(deliveryOrder) + setshowRemarks(false)
                        }
                        value="Delivery Order"
                      >
                        Delivery Order
                      </li>
                      <li
                        className="remarksOwn"
                        onClick={() => setInput()}
                        value="Remarks"
                      >
                        Write your own
                      </li>

                      <textarea
                        name="Text1"
                        rows="2"
                        placeholder="Type a note for this order..."
                        onChange={(e) => setRemarksMessage(e.target.value)}
                      ></textarea>
                    </div>
                  )}
                </div>

                <div className="ofTotal">
                  <span className="ofTotalLabel">Approx order value</span>
                  <span className="ofTotalValue">
                    <span className="ofCurrency">Rs.</span>
                    {increasePrice}
                  </span>
                </div>


                <button
                  type="button"
                  disabled={
                    orderclosed === false && order.orderItems.length === 0
                      ? true
                      : false
                  }
                  className="SubmitButton"
                  onClick={submitDatahandler}
                >
                  Submit order
                </button>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
              {/* Banners from OwnAppConfigs. They were forced to 100% x 300px,
                  which squashed any picture that is not exactly that shape.
                  Each now keeps its own proportions inside a fixed frame. */}
              {imges.length > 0 && (
                <div className="ofBanner">
                  <Carousel
                    style={{ zIndex: zIndex }}
                    autoplay={imges.length > 1}
                    dots={imges.length > 1}
                  >
                    {imges.map((a, index) => (
                      <div key={index} className="ofBannerSlide">
                        <Image
                          style={{ zIndex: zIndex }}
                          src={a}
                          alt="Offer"
                          preview={{ mask: "View" }}
                        />
                      </div>
                    ))}
                  </Carousel>
                </div>
              )}
            </div>
          </div>

          {
            <div className="modal" ref={refOne}>
              <Modal show={show} onHide={() => setShow(false)}>
                <div
                  className=" "
                  style={{
                    position: "absolute",
                    right: 5,
                    top: 5,
                  }}
                >
                  <FontAwesomeIcon
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShow(false);
                    }}
                    icon={faClose}
                    size="2x"
                    color="red"
                  />
                </div>
                {orderSuccess === "Success" && (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      style={{ marginLeft: "180px", marginTop: "20px" }}
                      width="100"
                      height="100"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#c8e6c9"
                        d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                      ></path>
                      <path
                        fill="#4caf50"
                        d="M34.586,14.586l-13.57,13.586l-5.602-5.586l-2.828,2.828l8.434,8.414l16.395-16.414L34.586,14.586z"
                      ></path>
                    </svg>

                    <h5
                      style={{
                        textAlign: "center",
                        color: " rgb(83, 82, 82)",
                        paddingBottom: "10px",
                        paddingTop: "20px",
                      }}
                    >
                      Your order was successfully submitted!
                    </h5>

                    <h6 className="orderNo" style={{ marginLeft: "120px" }}>
                      Your Order No :
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        {" " + submitOrderNo}
                      </span>
                    </h6>
                  </>
                )}
                {orderSuccess === "Failed" && (
                  <>
                    <Result
                      status="error"
                      title="Submission Failed"
                      subTitle="Please check and modify the following information before resubmitting."
                    >
                      <div className="desc">
                        <p>
                          <div
                            strong
                            style={{
                              fontSize: 16,
                            }}
                          >
                            The content you submitted has the following error:
                          </div>
                        </p>
                        {errorMessage}
                      </div>
                    </Result>
                  </>
                )}
              </Modal>
            </div>
          }
        </div>
        <CustomerFooter />
      </div>
    </div>
  );
}